import React from 'react'
import { StaticQuery, graphql } from 'gatsby'

import * as Styled from './styles/Header.styles'
import { NpfLogo } from './Icons'
import { linkResolver } from '../util/linkResolver'

const HEADER_QUERY = graphql`
  {
    prismicGeneralSiteSettings {
      data {
        helpline_phone_number
        donate_url {
          uid
          type
          link_type
          id
          url
        }
      }
    }
  }
`

const Header = () => (
  <Styled.HeaderContainer>
    <Styled.Header>
      {/* Only render Logo in above Tablet resolution */}
      <Styled.LogoLinkContainer to="/">
        <NpfLogo alt="NPF Logo" />
      </Styled.LogoLinkContainer>
      <StaticQuery
        query={`${HEADER_QUERY}`}
        render={data => {
          const doc = data.prismicGeneralSiteSettings.data
          return (
            <Styled.HelplineDonateContainer>
              <Styled.Helpline>
                Helpline&nbsp;
                <a href={`tel:${doc.helpline_phone_number}`}>
                  {doc.helpline_phone_number
                    ? doc.helpline_phone_number
                    : '800-723-9166'}
                </a>
              </Styled.Helpline>
              <Styled.DonateButton
                href={linkResolver(doc.donate_url)}
                target="_blank"
              >
                Donate
              </Styled.DonateButton>
            </Styled.HelplineDonateContainer>
          )
        }}
      />
    </Styled.Header>
  </Styled.HeaderContainer>
)

export default Header
